import { Navigate, useLocation } from "react-router-dom";

// ── Admin ─────────────────────────────────────────────────
// import AdminDashboard      from "../pages/admin/admin-dashboard";
import AdminRequests       from "../pages/admin/admin-requests";
import AdminRequestDetail  from "../pages/admin/admin-request-detail";
import AdminCompany        from "../pages/admin/admin-company";
import AdminBank           from "../pages/admin/admin-bank";
import AdminBuilding       from "../pages/admin/admin-building";
import AdminServiceProvider from "../pages/admin/admin-service-provider";
import AdminReportService from "../pages/admin/admin-report-service";
import AdminMessengers     from "../pages/admin/admin-messengers";
import AdminHoliday        from "../pages/admin/admin-holiday";
import AdminReport from "../pages/admin/admin-report-dashboard";
import Recurrent           from "../pages/admin/recurrent";

// ── User ──────────────────────────────────────────────────
// import UserDashboard       from "../pages/user/user-dashboard";
import UserRequests        from "../pages/user/user-requests";
import UserRequestDetail   from "../pages/user/user-request-detail";

// ── Report ────────────────────────────────────────────────
import ReportAdminRequests from "../pages/report/report-admin-requests";

// ── Authentication ────────────────────────────────────────
import Login               from "../pages/authentication/login";
import Logout              from "../pages/authentication/logout";
import Profile             from "../pages/authentication/profile";
import MessengerNoAccount  from "../pages/authentication/messenger-noaccount";

// ── Messenger ─────────────────────────────────────────────
import MessengerMyJob            from "../pages/messenger/messenger-my-job";
import MessengerProfile          from "../pages/messenger/messenger-profile";
import MessengerJobDetail        from "../pages/messenger/messenger-job-detail";
import MessengerJobDone          from "../pages/messenger/messenger-job-done";
import MessengerJobOverview      from "../pages/messenger/messenger-job-overview";
import MessengerJobCancelled     from "../pages/messenger/messenger-job-cancelled";
import MessengerJobIncomplete    from "../pages/messenger/messenger-job-incomplete";
import MessengerJobCompleteMulti from "../pages/messenger/messenger-job-complete-multi";

// ── Wrapper: force remount เมื่อ path เปลี่ยน ─────────────
const AdminRequestDetailPage = () => {
    const location = useLocation();
    return <AdminRequestDetail key={location.pathname} />;
};

// ─── Auth Routes ──────────────────────────────────────────
const authRoutes = [
    // User
    // { path: "/user/dashboard",          component: <UserDashboard /> },
    { path: "/user/requests",           component: <UserRequests /> },
    { path: "/user/request-detail/:id", component: <UserRequestDetail /> },

    // Admin - Requests
    // { path: "/admin/dashboard",             component: <AdminDashboard /> },
    { path: "/admin/requests",              component: <AdminRequests /> },
    { path: "/admin/request-detail/:id",    component: <AdminRequestDetailPage /> },

    // Admin - Master Data
    { path: "/admin/company",           component: <AdminCompany /> },
    { path: "/admin/building",          component: <AdminBuilding /> },
    { path: "/admin/bank",              component: <AdminBank /> },
    { path: "/admin/service-provider",  component: <AdminServiceProvider /> },
    { path: "/admin/report-service", component: <AdminReportService /> },
    { path: "/admin/messenger",         component: <AdminMessengers /> },
    { path: "/admin/holiday",           component: <AdminHoliday /> },
    { path: "/admin/recurrent",         component: <Recurrent /> },

    // Admin - Report
    { path: "/admin/report-dashboard",  component: <AdminReport /> },
    { path: "/admin/report-requests", component: <AdminReport /> },

    // Redirects
    { path: "/admin", component: <Navigate to="/admin/dashboard" /> },
    { path: "/user",  component: <Navigate to="/user/dashboard" /> },
    { path: "/",      component: <Navigate to="/login" /> },
];

// ─── Auth No Menu Routes ──────────────────────────────────
const authNoMenuRoutes = [
    { path: "/profile/:email", component: <Profile /> },
    { path: "/profile",        component: <Profile /> },
];

// ─── Public Routes ────────────────────────────────────────
const publicRoutes = [
    { path: "/login",               component: <Login /> },
    { path: "/messenger/noaccount", component: <MessengerNoAccount /> },
    { path: "/logout",              component: <Logout /> },
];

// ─── Messenger Routes ─────────────────────────────────────
const messengerRoutes = [
    { path: "/messenger/myjob",                          component: <MessengerMyJob /> },
    { path: "/messenger/profile",                        component: <MessengerProfile /> },
    { path: "/messenger/job-detail/:id",                 component: <MessengerJobDetail /> },
    { path: "/messenger/job-detail/:id/:seq",            component: <MessengerJobDetail /> },
    { path: "/messenger/job-done/:id/:seq/:total",       component: <MessengerJobDone /> },
    { path: "/messenger/job-overview/:id",               component: <MessengerJobOverview /> },
    { path: "/messenger/job-cancelled/:id/:refNo",       component: <MessengerJobCancelled /> },
    { path: "/messenger/job-incomplete/:id/:seq/:total", component: <MessengerJobIncomplete /> },
    { path: "/messenger/job-complete-multi/:id",         component: <MessengerJobCompleteMulti /> },
];

export { authRoutes, publicRoutes, authNoMenuRoutes, messengerRoutes };